'use strict';

export default {
  formAdmin: {
    addFieldWhenNoSections: 'Please add a section in this step before adding fields',
    save: ' Save',
    preview: ' Preview',
    lock: ' Lock',
    fields: 'Add Fields',
    properties: 'Properties',
    addButton: 'Add Option',
    enablePaymentError: 'Please enable payment for this form',
    noPaymentAccounts: 'Please create a Stripe payment account to use payments features',
    paymentModesError: 'An error occured with the payment modes. Please check your settings in the payment tab',
    editFormProperties: 'Edit form properties',
    choiceOptions: 'Choice Options',
    paymentOptions: 'Payment Options',
    discountCodesError: 'An error occured with the discount codes. Please check your settings in the payment tab',
    deleteLanguageConfirmation: `Are you sure you want to delete the {language, select, 
                                            fr { french }
                                            en { english }
                                            other {}
                                            } translation of this form?`,
    languageWarning:
      'Some texts have been modified in one language but not in the others. Are you sure you wish to continue without modifying them?',
  },
};
